import Vue from 'vue'
import axios from "axios"
import jwt_decode from 'jwt-decode'
import store from '../store'

export default {
	
	getProfile(jwt) {
		// see if we can get a user profile with the given JWT
		return axios.get('profile/', {
			baseURL: Vue.prototype.$apiUrl,
			headers: {Authorization: `Bearer ${jwt.access}`}
		})
	},
	
	refreshToken(jwt) {
		return axios.post('auth/token/refresh/', {refresh: jwt.refresh}, {
			baseURL: Vue.prototype.$apiUrl
		})
	},
	
	tokenHasExpired(jwt) {
		return (jwt && jwt_decode(jwt.access).exp < (Date.now() / 1000))
	},
	
	apiCall(endpoint, params) {
		return axios.get(endpoint + '/', {
			baseURL: Vue.prototype.$apiUrl,
			params: params
		})
	},
	
	authHeader(jwt) {
		return `Bearer ${jwt.access}`
	},
	
	getAuthHeader(index) {
		// refreshes the JWT as necessary, and returns whatever works in the promise as an auth header
		let account = store.state.auth.accounts[index]
		if (account) {
			if (this.tokenHasExpired(account.jwt)) {
				return this.refreshToken(account.jwt).then(response => {
					store.commit('updateAccountJWT', {index: index, jwt: response.data})
					return Promise.resolve(this.authHeader(response.data))
				}).catch(e => {
					return Promise.reject(e)
				})
			} else {
				return Promise.resolve(this.authHeader(account.jwt))
			}
		} else {
			return Promise.reject('No active account authentication')
		}
	}
}
